<template>
    <div
        class="l-ss-c-search-popup-wrapper l-ss-c-search-popup-wrapper-inbuilt">
        <div
            :class="{ 'l-ss-c-search-popup-wrapper-mask-hidden': isShowAgeCheckPopup }"
            style="z-index: 100"
            class="l-ss-c-search-popup-wrapper-mask"
            @mousedown="mousedownClose"
            @click.self="clickClose">
            <div
                v-if="isLoading && false"
                class="l-ss-c-results-loader">
                <pulse-dots/>
            </div>

            <div
                v-else
                :class="{
                    [`l-ss-c-search-popup-is-opened-mobile-nav`]: showMobileNavigation,
                    [`l-ss-c-search-popup-is-loading`]: isLoading,
                    [`l-ss-c-search-popup-is-masked`]: isMaskVisible,
                    ...wrapperClasses,
                }"
                class="l-ss-c-search-popup">
                <div
                    v-if="$configuration.showInput"
                    :style="topSectionWrapperStyles"
                    class="l-ss-c-search-result-top-section-wrapper l-ss-c-search-result-content-wrapper-child">
                    <div
                        v-if="isResultsVisible"
                        class="l-ss-c-popup-slot-top">
                        <autocomplete
                            :is-loading="isLoading"
                            :search="search"
                            class="l-ss-c-popup-slot-top-column l-ss-c-popup-slot-top-column-is-left"
                            @autocomplete-search="val => $emit('autocomplete-search', val)"
                            @params-search="params => $emit('params-search', params)"/>
                    </div>
                </div>
                <div
                    v-show="isMaskVisible"
                    class="l-ss-c-search-popup-mask"
                    @click="onPopupMaskClick"></div>
                <popup
                    :opened="store.state.ui.isFiltersOpened"
                    :title="$t('filters.titleAll')"
                    class="l-ss-c-search-popup-filters-popup"
                    @close="() => toggleFilters(false)">
                    <section-full-filters
                        :filters="filterItems"
                        :has-results="hasResults"
                        :has-selected="hasFilters"
                        :total-items-count="totalItemsCount"
                        :values="filterValues"
                        @change="filters => $emit('filters-change', filters)"
                        @close="() => toggleFilters(false)"
                        @reset="() => $emit('reset-filters')"/>
                </popup>
                <age-check-popup
                    v-if="isShowAgeCheckPopup"
                    :is-show="true"
                    @close="() => toggleAgeCheckPopup(false)"
                    @deny="onDenyAgeCheck"/>
                <div class="l-ss-c-search-result-content-wrapper">
                    <div
                        :class="{ 'l-ss-c-filters-left': filterPositionLeft }"
                        :style="!$configuration.showInput ? 'padding-top: 0' : ''">
                        <section-image
                            v-show="(store.state.ui.isImageContours || base64Image) && image"
                            :image="store.state.ui.isImageContours || { contours: [], src: '' }"
                            :key="sectionImageKey"
                            @search="onImageSearch"
                            @crop-change="onCropChange"
                            @contour-click="$contour => $emit('contour-click', $contour)"/>
                        <div :class="{ 'l-ss-c-filters-left-container': filterPositionLeft }">
                            <section-filters
                                v-show="isFiltersBlockVisible && isResultsVisible"
                                :currency="currencyInOffers"
                                :filter-position-left="filterPositionLeft"
                                :filters="filterItems"
                                :has-results="hasResults"
                                :has-selected="hasFilters"
                                :show-sorting="showSorting"
                                :sort-by="sortBy"
                                :sort-dest="sortDest"
                                :total-items-count="totalItemsCount"
                                :values="filterValues"
                                search-type="search-results"
                                class="l-ss-c-search-popup-content-wrapper-child"
                                @change="filters => $emit('filters-change', filters)"
                                @sort-change="params => $emit('sort-change', params)"
                                @reset-filters="() => $emit('reset-filters')"
                                @close-filters="() => toggleFilters(false)"
                                @open-filters="() => toggleFilters(true)"
                                @toggle-image-picker="event => toggleImagePicker(event)"/>
                            <section-results
                                v-if="isResultsVisible"
                                ref="search-results"
                                :categories="allCategoriesList"
                                :category-id="resultsCategoryId"
                                :error-text="requestErrorText"
                                :filter-position-left="filterPositionLeft"
                                :group-categories="$configuration.features.shouldGroupCategories"
                                :has-filters="hasFilters"
                                :has-loaded-once="hasLoadedOnce"
                                :has-query="hasQuery"
                                :has-results="hasResults"
                                :is-loading="isLoading"
                                :limit="limit"
                                :search="searchResponse"
                                :search-request-id="searchRequestId"
                                :skip="skip"
                                :templates="offerTemplates"
                                :total-items-count="totalItemsCount"
                                :query="query"
                                class="l-ss-c-search-popup-content-wrapper-child"
                                @navigate-category="handleNavigateCategory"
                                @navigate-page-next="() => $emit('navigate-page-next')"
                                @navigate-page-prev="() => $emit('navigate-page-prev')"
                                @reset-category="() => $emit('navigate-category', emitNavigateCategory({ skip: 0, categoryId: '' }))"
                                @offer-click="params => $emit('offer-click', params)"
                                @add-to-cart="args => onSearchInputAction('add-to-cart', args)"
                                @reset-filters="() => $emit('reset-filters')"
                                @reset-query="() => $emit('reset-query')"
                                @handle-tags-click="(value) => onTapAction(value)"
                                @page-reload="handlePageReload"
                                @scroll-to-top="handleScrollToTop">
                                <template #filtersSort>
                                    <section-filters-sort
                                        v-if="isFiltersBlockVisible && isResultsVisible && filterPositionLeft"
                                        :filter-position-left="filterPositionLeft"
                                        :filters="filterItems"
                                        :show-sorting="showSorting"
                                        :sort-by="sortBy"
                                        :sort-dest="sortDest"
                                        class="l-ss-c-search-popup-content-wrapper-child"
                                        @sort-change="params => $emit('sort-change', params)"/>
                                </template>
                                <template #top>
                                    <custom-block
                                        v-if="$configuration.searchResult.topBlock"
                                        :custom-template="$configuration.searchResult.topBlock"/>
                                    <info-banner v-if="from_completions">
                                        <span>{{ $t('selectedFiltersText') }}: {{ from_completions }}</span>
                                        <button
                                            class="l-ss-c-button l-ss-c-filters-full-action l-ss-c-button-secondary"
                                            @click="() => $emit('reset-filters')">
                                            {{ $t('filters.resetAllText') }}
                                        </button>
                                    </info-banner>
                                    <info-banner v-show="search && search.hits > $configuration.limitForQueryRefine">
                                        <span>{{ $t('results.overLimitResults') }}</span>
                                    </info-banner>
                                </template>
                            </section-results>
                        </div>
                    </div>

                    <div
                        v-if="isShowSignature"
                        class="l-ss-c-signature">
                        <a
                            ref="signatureLeft"
                            class="l-ss-c-signature__caption"></a>
                        <a
                            ref="signatureRight"
                            class="l-ss-c-signature__caption"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { installPlugins } from '../core/plugins';
    import Autocomplete from '../core/components/autocomplete';
    import RootComponentMixin from '../core/mixins/root-component';
    import CompletionsMixin from '../core/mixins/completions';
    import SearchResultsMixin from '../core/mixins/search-results-mixin';
    import SectionResults from '../core/components/section-results';
    import SectionFilters from '../core/components/filters/section-filters';
    import iconClosePopup from '../core/assets/images/icons/close-popup.svg';
    import Popup from '../core/components/popup';
    import AgeCheckPopup from '../core/components/age-check-popup';
    import InfoBanner from '../core/components/info-banner';
    import SectionFullFilters from '../core/components/filters/section-full-filters';
    import SectionFiltersSort from '../core/components/filters/section-filters-sort';
    import CustomBlock from '../core/components/custom-block';
    import SectionImage from '@/core/components/section-image';
    import PulseDots from '@/core/components/pulse-dots';
    import { getCookie } from '/src/core/helpers/cookies';

    const EVENT_CALLBACK_DELAY = 300;
    const POPOVER_Z_INDEX = 52;
    installPlugins();
    export default {
        components: {
            SectionImage,
            SectionFullFilters,
            Autocomplete,
            SectionFilters,
            SectionResults,
            InfoBanner,
            Popup,
            CustomBlock,
            AgeCheckPopup,
            SectionFiltersSort,
            PulseDots,
        },
        props: {
            ...CompletionsMixin.props,
            ...RootComponentMixin.props,
            ...SearchResultsMixin.props,
            from_completions: {
                type: String,
                default: '',
            },
            categoryId: {
                type: [String, Number],
                default: '',
            },
            query: {
                type: String,
                default: '',
            },
            params: {
                type: Array,
                default: () => ([]),
            },
            completions: {
                type: Array,
                required: false,
                default: () => ([]),
            },
            requestCategories: {
                type: Object,
                required: false,
                default: () => null,
            },
        },
        data() {
            return {
                localQueryParams: null,
                showMobileNavigation: false,
                base64Image: null,
                base64ImageResult: null,
                showSearch: true,
                wrapperClickTarget: null,
                isBase64ImageChanged: false,
                sectionImageKey: '',
            };
        },

        computed: {
            ...CompletionsMixin.computed,
            ...RootComponentMixin.computed,
            ...SearchResultsMixin.computed,
            filterPositionLeft() {
                return this.$configuration.layout.filterPosition === 'left' && !this.$screen.isMobile && this.totalItemsCount >
                    0;
            },
            topSectionWrapperStyles() {
                return {
                    zIndex: this.isTopSectionOnFrontLayer ? POPOVER_Z_INDEX : 'initial',
                    paddingLeft: '32px',
                    backgroundColor: this.store.state.ui.isCompletionsVisible && !this.$screen.isMobile ?
                        'transparent' :
                        'inherit',
                };
            },
            requestErrorText() {
                return this.errorTextCompletions || this.errorTextSearch || '';
            },
            isMaskVisible() {
                return this.store.state.ui.isImageSearchVisible ||
                    this.store.state.ui.isCategoriesListVisible ||
                    this.store.state.ui.isFiltersOpened ||
                    this.showCompletions;
            },
            isTopSectionOnFrontLayer() {
                return (this.store.state.ui.isCategoriesListVisible && !this.$screen.isMobile) || this.showCompletions;
            },
            isShowSignature() {
                return Boolean(this.hasResults) && this.store.state.ui.isShowSignature;
            },
            iconClosePopup() {
                return iconClosePopup;
            },
            isCategoriesLoading() {
                return this.requestCategories ? this.requestCategories.isLoading : false;
            },
            isLoading() {
                return this.isCompletionsLoading || this.isSearchLoading || this.isCategoriesLoading;
            },
            categoriesResponse() {
                return this.requestCategories ? this.requestCategories.response : null;
            },
            allCategoriesList() {
                return this.categoriesResponse || [];
            },
            showSorting() {
                return (Boolean(this.hasResults));
            },
            isShowAgeCheckPopup() {
                return this.store.state.ui.isShowAgeCheckPopup;
            },
            hasImageSearchResults() {
                return Boolean(this.searchState.private && this.searchState.private.image);
            },
            image() {
                return this.hasImageSearchResults ? this.searchState.private.image : '';
            },
        },

        watch: {
            'searchState.public': function (state) {
                if (this.localQueryParams && this.localQueryParams.query !== state.query) {
                    this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                    this.base64ImageResult = null;
                }
                this.localQueryParams = state ? { ...state } : {};
            },
            'store.state.ui.isCompletionsVisible': {
                handler(value) {
                    if (value && !this.isFocused && this.value) {
                        this.$refs.input.focus();
                        this.isFocused = true;
                    }
                },
            },
            'store.state.base64ImageResult': {
                handler(value) {
                    if (this.store.state.base64ImageResult) {
                        this.isBase64ImageChanged = true;
                        this.onImageSearch(this.store.state.base64ImageResult);
                    }
                },
            },
            'store.state.base64Image': {
                handler(value) {
                    this.base64Image = this.store.state.base64Image;
                },
            },
            base64Image() {
                this.isBase64ImageChanged = true;
            },
        },

        beforeCreate() {
            Object.assign(this, { projectName: 'SearchBooster.io' });
            Object.assign(this, { href: 'https://searchbooster.io/' });
        },

        mounted() {
            this.$on('search-input-change', () => {
                this.base64Image = null;
                this.base64ImageResult = null;
            });
            this.$on('handle-search', () => {
                this.base64Image = null;
                this.base64ImageResult = null;
            });
            this.addCss(this.$configuration.searchResult.topBlock.customCss);
        },

        updated() {
            this.setValueToSignature();
        },

        methods: {
            ...RootComponentMixin.methods,
            ...SearchResultsMixin.methods,
            toggleImagePicker(event) {
                this.toggleImageSearch(true);
                this.$emit('button-image-click', { type: 'buttonImageClick', event });
            },
            addCss(cssCode) {
                let shDom = document.querySelector('searchbooster-search-results');
                let style = document.createElement('style');
                if (style.styleSheet) {
                    style.styleSheet.cssText = cssCode;
                } else {
                    style.appendChild(document.createTextNode(cssCode));
                }
                shDom.shadowRoot.appendChild(style);
            },
            clickClose(event) {
                if (this.wrapperClickTarget === event.target) this.$emit('search-popup-close');
            },
            mousedownClose(event) {
                this.wrapperClickTarget = event.target;
            },
            onToggleCategories(value) {
                const resultValue = value === undefined ? !this.store.state.ui.isCategoriesListVisible : !!value;
                if (resultValue) {
                    this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
                }
                this.store.state.ui.isCategoriesListVisible = resultValue;
                if (resultValue) {
                    this.$emit('search-popup-fetch-categories');
                }
            },
            onFileBase64Change(base64Image) {
                this.base64Image = base64Image;
            },
            onCropChange(event) {
                this.base64ImageResult = event.canvas.toDataURL('image/jpeg');
            },
            onImageSearch(base64ImageResult) {
                if (base64ImageResult) {
                    this.base64ImageResult = base64ImageResult;
                }

                if (this.isBase64ImageChanged) {
                    this.isBase64ImageChanged = false;
                    this.sectionImageKey = this.base64Image;
                }

                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.$emit('search-image', { base64: this.base64ImageResult });
                /*
                 * SetTimeout(() => {
                 *     this.base64Image = null;
                 *     this.base64ImageResult = null;
                 * }, RESET_IMAGE_BASE_64_DELAY);
                 */
            },
            toggleImageSearch(value) {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isImageSearchVisible',
                    value: value === undefined ? !this.store.state.ui.isImageSearchVisible : !!value,
                });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
                this.base64Image = null;
                this.base64ImageResult = null;
            },
            toggleAgeCheckPopup() {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isShowAgeCheckPopup',
                    value: !this.store.state.ui.isShowAgeCheckPopup,
                });
            },
            onPopupMaskClick() {
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.base64Image = null;
                this.base64ImageResult = null;
            },
            onSearchInputAction(eventName, params) {
                let afterEventCallback = null;
                switch (eventName) {
                    case 'search-input-change':
                        this.$emit(eventName, params);
                        break;
                    case 'handle-search':
                        this.toggleFilters(false);
                        this.$emit(eventName);
                        break;
                    case 'toggle-image-picker':
                        this.toggleImageSearch(params);
                        break;
                    case 'popup-close':
                        this.$emit('search-popup-close');
                        break;
                    case 'search-input-blur':
                        this.$emit('search-input-blur');
                        break;
                    case 'search-input-focus':
                        this.$emit('search-input-focus');
                        break;
                    case 'search-input-enter':
                        this.$emit(eventName, params);
                        break;
                    case 'reset-query':
                        this.base64Image = null;
                        this.$emit(eventName, params);
                        break;
                    case 'add-to-cart':
                        this.$emit(eventName, params);
                        break;
                    case 'remove-history':
                        this.$emit('remove-history');
                        break;
                    default:
                        afterEventCallback = () => {
                            this.showSearch = true;
                        };
                        this.$emit(eventName, params);
                }
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                if (afterEventCallback) {
                    setTimeout(afterEventCallback, EVENT_CALLBACK_DELAY);
                }
            },
            setValueToSignature() {
                if (!this.isShowSignature)
                    return;
                const i18nStr = this.$t('signature', [this.projectName]);
                const preparedValue = i18nStr.replace(this.projectName, '');
                const refsList = i18nStr.indexOf(this.projectName) === 0
                    ? [this.$refs.signatureLeft, this.$refs.signatureRight]
                    : [this.$refs.signatureRight, this.$refs.signatureLeft];
                if (!refsList.some(Boolean))
                    return;
                refsList[0].innerText = this.projectName;
                refsList[0].href = this.href;
                refsList[0].target = '_blank';
                refsList[1].innerText = preparedValue;
            },
            onTapAction(value) {
                this.$emit('search-input-change', { query: value, focus: false });
                this.onSearchInputAction('handle-search');
            },
            onDenyAgeCheck() {
                if (this.$configuration.features.ageCheckPopupType === 'filter') {
                    this.$emit('search-all');
                } else {
                    this.$emit('reset-query');
                    this.$emit('search-popup-close');
                    window.location.href = getCookie('ageCheckPopupRedirectUrl', this.$configuration.ageCheckPopupRedirectUrl);
                }
            },
        },
    };
</script>
